/**
 * Full-screen branded loading state shown while the startup auth check
 * (token refresh) is in flight. Prevents a blank white page when a returning
 * user lands with an expired access token that's being silently refreshed.
 */
export default function AuthLoadingScreen() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        height: '100vh',
        width: '100vw',
        background: '#ffffff',
      }}
    >
      <img
        src="/favicon.svg"
        alt="CrewCast"
        width={72}
        height={72}
        style={{ borderRadius: 16 }}
      />
      <div
        style={{
          width: 28,
          height: 28,
          border: '3px solid #e5e7eb',
          borderTopColor: '#00bf62',
          borderRadius: '50%',
          animation: 'authLoadingSpin 0.7s linear infinite',
        }}
      />
      <style>{`@keyframes authLoadingSpin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
